import { createContext } from "react";

export const WorkspaceModalContext = createContext();
